import { Link, Typography, TypographyProps } from '@mui/material';

interface LinkifyTextProps extends TypographyProps {
  text: string;
}

export default function LinkifyText({ text, variant, ...typographyProps }: LinkifyTextProps) {
  if (!text) {
    return <></>;
  }

  const convertTextToLinks = (text: string) => {
    const urlRegex = /\b(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;

    const elements: React.ReactNode[] = [];
    let currentIndex = 0;
    let urlMatch;

    while ((urlMatch = urlRegex.exec(text)) !== null) {
      if (urlMatch.index > currentIndex) {
        elements.push(text.substring(currentIndex, urlMatch.index));
      }
      const url = urlMatch[0];
      elements.push(
        <Link
          key={`${url}-${urlMatch.index}`}
          href={url.startsWith('http') ? url : `http://${url}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </Link>
      );
      currentIndex = urlMatch.index + url.length;
    }
    if (currentIndex < text.length) {
      elements.push(text.substring(currentIndex));
    }
    return elements;
  };

  return (
    <Typography variant={variant} component="span" {...typographyProps}>
      {convertTextToLinks(text)}
    </Typography>
  );
}
